'use es6';

import PropTypes from 'prop-types';
import FormattedList from 'I18n/components/FormattedList';
import { jsx as _jsx } from "react/jsx-runtime";
const AppIntegrations = ({
  integrations
}) => /*#__PURE__*/_jsx(FormattedList, {
  children: [...integrations].sort().map(integration => /*#__PURE__*/_jsx("span", {
    children: integration
  }, integration))
});
AppIntegrations.propTypes = {
  integrations: PropTypes.array
};
export default AppIntegrations;